import { ApiBase } from '../ApiBase';
class MembershipsBadgesApiClientModel extends ApiBase {
    constructor() {
        super(...arguments);
        this.getBadges = () => {
            return this.get('/creators/api/v1/badges');
        };
        this.createCustomBadge = (requestBody) => {
            return this.post('/creators/api/v1/badges/customs', requestBody);
        };
        this.editCustomBadge = (params, requestBody) => {
            return this.patch(`/creators/api/v1/badges/customs/${params.id}`, requestBody);
        };
        this.enableCustomBadge = (params) => {
            return this.post(`/creators/api/v1/badges/customs/${params.id}/enable`);
        };
        this.disableCustomBadge = (params) => {
            return this.post(`/creators/api/v1/badges/customs/${params.id}/disable`);
        };
        this.deleteCustomBadge = (params) => {
            return this.delete(`/creators/api/v1/badges/customs/${params.id}`);
        };
        this.editMemberStreakBadge = (requestBody) => {
            return this.patch('/creators/api/v1/badges/member_streak', requestBody);
        };
        this.enableMemberStreakBadge = () => {
            return this.post('/creators/api/v1/badges/member_streak/enable');
        };
        this.disableMemberStreakBadge = () => {
            return this.post('/creators/api/v1/badges/member_streak/disable');
        };
    }
}
export const MembershipsBadgesApiClient = new MembershipsBadgesApiClientModel('/');
